import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row, Switch } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import PrecisionAlertModal from '../../components/PrecisionAlertModal/PrecisionAlertModal'

interface FP16SwitchProps {
  fieldName: string
}

const FP16Switch = ({ fieldName }: FP16SwitchProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <Row>
        <Col xs={10}>
          <div onMouseLeave={() => setTouched(true)}>
            <Switch
              id={`${name}SwitchId`}
              text={t('{{ precision }} model precision', { precision: 'FP16' })}
              title="Enable FP16 precision for training."
              isToggled={value}
              disabled={isSubmitting}
              onToggle={() => {
                setValue(!value)
              }}
              error={!!(error && touched)}
              errorMessage={error}
            />
          </div>
        </Col>
        <Col xs={2} alignRight>
          <FontAwesomeIcon
            size="lg"
            icon={faCircleQuestion}
            onClick={() => setShowModal(true)}
          />
        </Col>
      </Row>
      {showModal && (
        <PrecisionAlertModal
          action="info"
          handleClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}

export default FP16Switch
